import {
  ALL_SOCIAL_PLATFORM_TYPE,
  PARTIALLY_SUPPORTED_PLATFORMS,
  SOCIAL_PLATFORMS,
} from '~/constants';
import {
  IApiSearchContent,
  IApiSearchInstagramContent,
} from '~/searchApi/content';

export const formatPlatformName = (platform?: ALL_SOCIAL_PLATFORM_TYPE) => {
  const platformMap: Record<ALL_SOCIAL_PLATFORM_TYPE, string> = {
    [SOCIAL_PLATFORMS.instagram]: 'Instagram',
    [SOCIAL_PLATFORMS.tiktok]: 'TikTok',
    [SOCIAL_PLATFORMS.youtube]: 'YouTube',
    [PARTIALLY_SUPPORTED_PLATFORMS.snapchat]: 'Snapchat',
  };

  return platformMap[platform as ALL_SOCIAL_PLATFORM_TYPE] || 'Unknown';
};

export const formatProductType = (contentData?: IApiSearchContent) => {
  if (!contentData) return 'UNKNOWN';

  const productTypeMap: Record<string, string> = {
    reels: 'REELS',
    feed: 'STILL',
    story: 'STORY',
    post: 'POST',
    image: 'IMAGE',
    video: 'VIDEO',
  };

  // For Instagram, use the 'productType' property
  if (contentData.platform === SOCIAL_PLATFORMS.instagram) {
    const instagramContent = contentData as IApiSearchInstagramContent;
    if (instagramContent.productType) {
      return (
        productTypeMap[instagramContent.productType.toLowerCase()] || 'UNKNOWN'
      );
    }
    return 'UNKNOWN';
  }

  // For TikTok and YouTube, use the 'type' property (both are video)
  if (
    contentData.platform === SOCIAL_PLATFORMS.tiktok ||
    contentData.platform === SOCIAL_PLATFORMS.youtube
  ) {
    return productTypeMap[contentData.type] || 'UNKNOWN';
  }

  return 'UNKNOWN';
};
